import { FC, MouseEvent } from 'react'
import { useMySelector } from 'featureSliced/shared/hooks/useMySelector'
import { IProduct } from 'featureSliced/shared/store/reducers/CategoriesReducer/types'
import { roundValueTo } from 'featureSliced/shared/utils/roundValueTo'
import { ProductGrided } from '../ProductGrided/ProductGrided'
import { ProductListed } from '../ProductListed/ProductListed'
import { ProductsGrid, ProductsList } from '../styled'

type ProductsProps = {
  products: IProduct[]
  templateId: number
  onProductClick: (product: IProduct, e: MouseEvent<HTMLElement>) => void
}

export const MenuProducts: FC<ProductsProps> = ({
  products,
  templateId,
  onProductClick,
}) => {
  // Store
  const selectedProducts = useMySelector((state) => state.bucket.products)
  const { productViewType } = useMySelector(
    (state) => state.app.interfaceStyles
  )

  const ContainerComponent =
    productViewType === 'list' ? ProductsList : ProductsGrid
  const ProductsComponent =
    productViewType === 'list' ? ProductListed : ProductGrided

  // Functions
  const getAmount = (product: IProduct) => {
    return selectedProducts?.reduce((acc, curr) => {
      if (
        curr.productId === product.id &&
        curr.productTemplateId === templateId
      ) {
        return roundValueTo(acc + curr.count)
      } else {
        return acc
      }
    }, 0)
  }

  return (
    <ContainerComponent>
      {products?.slice()?.map((product, i) => {
        return (
          <ProductsComponent
            // withLazy
            key={`${product?.id}_${i}`}
            product={product}
            templateId={templateId}
            amount={getAmount(product)}
            onProductClick={onProductClick}
            showPricePerItem={true}
          />
        )
      })}
    </ContainerComponent>
  )
}
